import React, { useEffect } from 'react'
import { toLocaleDate } from 'utils/date-fns'
import TableCreditScore from 'components/TableCreditScore'
import PageWrapper from 'components/PageWrapper'
import CustomDisclosure from 'components/Disclosure'
import { ErrorBoundary } from '@sentry/react'
import { InstitutionsHeader } from 'components/creditScore'
import { trackEvent } from 'analytics/trackFunctions'
import { scorePositionMap } from 'utils/moengageEvents'
import { useCreditScoreStore } from 'store'

const TableDebtsInstitution = () => {
  const { creditScore } = useCreditScoreStore()

  useEffect(() => {
    if (creditScore)
      trackEvent({
        eventName: 'bille_sc_institucion',
        props: { position: scorePositionMap[creditScore.position] }
      })
  }, [creditScore])

  return (
    <PageWrapper
      className='!px-0'
      mobileHeaderColor={creditScore?.position}
      viewSelected='/home'
      title='Información por institución'
    >
      <section className='h-full flex md:justify-center flex-col'>
        <div className='flex-col md:px-5 flex md:flex-row md:items-center md:justify-center'>
          <InstitutionsHeader
            amount={creditScore?.debt_total_amount}
            score={creditScore?.position}
            updateTime={toLocaleDate(creditScore?.last_checked_date)}
          />

          <ErrorBoundary>
            <TableCreditScore
              data={creditScore?.debts}
              className='md:w-3/5 xl:w-[30%] lg:pl-12'
            />
          </ErrorBoundary>
        </div>

        <div className='px-3 pb-20 md:mt-10 md:pb-0 md:h-20 md:max-w-lg md:mx-auto'>
          <CustomDisclosure
            qn='¿Cuánto tiempo se demora en excluirme de la Central de deudores luego de cancelar mi deuda?'
            ans='El Banco Central demora aproximadamente 1 mes en actualizar su base. Esto quiere decir que si cancelas tu deuda recién vas a poder ver ese pago impactado al mes próximo. Tené en cuenta que el Banco Central difunde tu historial crediticio de los últimos 24 meses, por lo que los registros continuarán informándose por ese período de tiempo a partir del mes en que se produjo la cancelación.'
          />
        </div>
      </section>
    </PageWrapper>
  )
}
export default TableDebtsInstitution
